export default class NfSaidaEnderecoCliente {
  id = null;
  complemento = null;
  codigoIbge = null;
  cep = null;
  logradouro = null;
  numero = null;
  bairro = null;
  cidade = null;
  estado = null;
  pessoaId = null;
  estadoId = null;
  pais = null;
  bacen = null;

  constructor(nfSaidaEnderecoCliente) {
    this.id = nfSaidaEnderecoCliente?.id;
    this.complemento = nfSaidaEnderecoCliente?.complemento;
    this.codigoIbge = nfSaidaEnderecoCliente?.codigoIbge;
    this.cep = nfSaidaEnderecoCliente?.cep;
    this.logradouro = nfSaidaEnderecoCliente?.logradouro;
    this.numero = nfSaidaEnderecoCliente?.numero;
    this.bairro = nfSaidaEnderecoCliente?.bairro;
    this.cidade = nfSaidaEnderecoCliente?.cidade;
    this.estado = nfSaidaEnderecoCliente?.estado;
    this.pessoaId = nfSaidaEnderecoCliente?.pessoaId;
    this.estadoId = nfSaidaEnderecoCliente?.estadoId;
    this.pais = nfSaidaEnderecoCliente?.pais;
    this.bacen = nfSaidaEnderecoCliente?.bacen;
  }

  setEnderecoEmpresaDestino(empresa) {
    this.complemento = empresa?.enderecoComplemento;
    this.cep = empresa?.enderecoCep;
    this.logradouro = empresa?.enderecoLogradouro;
    this.numero = empresa?.enderecoLogradouroNumero;
    this.bairro = empresa?.enderecoBairro;
    this.cidade = empresa?.cidade?.nome;
    this.estado = empresa?.cidade?.estado?.sigla;
    this.estadoId = empresa?.cidade?.estado?.id;
  }
}
